export function stripBase64Prefix(base64Data: string): string {
    const prefixRegex = /^data:[a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+;base64,/;
    return base64Data.replace(prefixRegex, '');
}
